import React, { useEffect } from 'react';
import { getClientId } from 'utils';
import { clearClient } from 'prodivers/clientProfile';
import { useMainLayout } from 'hooks/useMainLayout';
import { useLocation, useParams } from 'react-router-dom';

const mainLayout = (
    WrappedComponent: React.ComponentType<Record<string, unknown>>,
) => {
    const MainLayout = (props: Record<string, unknown>) => {
        const { dfsClientId } = useParams();

        const { pathname } = useLocation();
        const clientId = getClientId(dfsClientId);

        useEffect(() => clearClient(), []);
        useMainLayout({ pathname });

        return (
            <WrappedComponent
                dfsClientId={dfsClientId}
                clientId={clientId}
                {...props}
            />
        );
    };

    return MainLayout;
};

export default mainLayout;
